<div class="auth-container">
	<div class="auth-wrapper">
		<figure class="auth-logo">
			<img src="./assets/images/logo-ivsw.svg" alt="Logo IVSW" />
		</figure>
		<app-login-form (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"></app-login-form>
	</div>
</div>
